import { twMerge } from 'tailwind-merge';

const Input = ({ ...props }) => {
	return <input {...props} className={twMerge(`block w-full rounded-md bg-white h-9 px-3 py-1.5 border !border-gray-200 text-gray-900 placeholder:text-gray-400 font-normal text-sm !outline-none !ring-0 !ring-transparent focus:!outline-none focus:!ring-0 focus:!ring-transparent focus-visible:!outline-none focus-visible:!ring-0 focus-visible:!ring-transparent`, props.className)} />;
};

export default Input;